<template>
  <div class="general">
    <MainHeader>
      {{$ml.get('Fertilization Report')}}
    </MainHeader>
    <Details/>
    <HeadLine>
      {{$ml.get('Tests')}}
    </HeadLine>
    <div class="tests">
      <ValueField v-if="program.type != 'hydroponic'" :label="$ml.get('Soil test')" :value="!!program.soilTest"/>
      <ValueField :label="$ml.get('Tissue test')" :value="!!program.tissueTest"/>
      <ValueField :label="$ml.get('Water test')" :value="!!program.waterTest"/>
    </div>
    <HeadLine>
      {{$ml.get('Crop')}}
    </HeadLine>
    <div class="crop th-fields-container">
      <div class="column">
        <ValueField :label="$ml.get('Crop')" :value="$ml.get(program.crop.name)"/>
        <ValueField :label="$ml.get('Growing method')" :value="$ml.get(program.cropGrowingMethod.name)"/>
      </div>
      <div class="column">
        <ValueField :label="$ml.get('Type')" :value="$ml.get(program.cropVariety.name)"/>
        <ValueField 
          v-if="program.type != 'hydroponic'"
          :label="$ml.get('Yield Goal')" 
          :value="$ml.get(yieldGoalValue)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Details from './../components/general/Details';
import MainHeader from './../components/common/MainHeader';
import HeadLine from './../components/common/HeadLine';
import ValueField from './../components/common/ValueField';

export default {
  data() {
    return {
      program: {}
    }
  },
  components: {
    Details,
    MainHeader,
    HeadLine,
    ValueField,
  },
  methods: {

    
  },
  beforeMount() {
    this.program = this.$root.data.program;
  },
  computed: {

    // program() {
    //   return this.$root.data.program
    // },

    yieldGoalValue() {
      if(this.program.type == 'hydroponic') {
        return '-';
      } else {
        return this.$store.getters['unit/convert']('t/ha', this.program.cropYieldGoal.goal) + ' ' + this.$store.getters['unit/getLabel']('t/ha');
      }
    }
  },
}
</script>

<style lang="scss" scoped>

.general {
  .tests {
    display: flex;
    flex-direction: row;
    align-content: stretch;
  
    padding-bottom: 50px;
    padding-top: 20px;

    > * {
      flex-grow: 1;
      margin-right: 40px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .crop {
    padding-bottom: 20px;
    padding-top: 20px;
  }
}

</style>